import _ from 'lodash'
import analyzeResultService from './service/analyzeresult'
import chartOptionUtil from './utils/chartoption'

const state = {
  initLoaded: false,
  dataItems: null,
  tabType: null,
  analyzeTargetCode: '',
  chartOptions: [],
  reportsOnDashboard: {},
  chartData: {
    analyzeTargetCode: '',
    historyId: -1,
    chartOptions: {},
    tabDatas: {}
  },
  if00025Info: {}
}

const actions = {
  async getChartData ({ state, commit }, { targetCode, historyId, type, conditions, yAxis, ages }) {
    commit('setListLoading', true)
    commit('clearChartData')
    commit('setCharDataAnalyzeTargetCode', targetCode)
    commit('setCharDataHistoryId', historyId)
    const response = await analyzeResultService.getChartData(historyId, type, yAxis)
    if (response.data.code !== 200000) {
      commit('processError', response.data.data.message)
    } else {
      let chartData = {
        data: response.data.data,
        type: type,
        conditions: conditions,
        yAxis: yAxis,
        ages: ages
      }
      commit('setChartData', chartData)
    }
  },
  async getChartDataOnDashboard ({ state, commit }, { report, ages }) {
    const analyzeTargetCode = report.analyze_target_code
    if (chartOptionUtil.hasChart(analyzeTargetCode)) {
      let type = chartOptionUtil.getDefaultTab(analyzeTargetCode)
      const response = await analyzeResultService.getChartData(report.history_id, type)
      commit('setChartDataOnDashboard', { response: response, report: report, ages: ages })
    } else {
      commit('setChartDataOnDashboard', { response: null, report: report })
    }
  }
}

const mutations = {
  setListLoading (state, data) {
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  processError (state, data) {
    state.message = { type: 'error', content: data }
    this.dispatch('loading/loadingPageMinus')
  },
  clearChartData (state) {
    state.chartOptions = []
  },
  setChartData (state, chartData) {
    state.items = chartData.data.detail_info

    if (state.chartData.analyzeTargetCode === 'IF00025') {
      state.if00025Info = state.items[0]
    } else {
      let stateChartOptions = chartOptionUtil.createChartOptions(
        state.items, chartData.conditions.type, chartData.conditions.groupby,
        chartData.conditions.type_mode, chartData.type, chartData.yAxis,
        chartData.conditions.term, chartData.ages)
      state.chartOptions = stateChartOptions
    }
    this.dispatch('loading/loadingPageMinus')
  },
  setChartDataOnDashboard (state, param) {
    const response = param.response
    const report = param.report

    report.chartOptions = null
    if (response && response.data.code === 200000) {
      let chartData = {
        data: response.data.data,
        type: chartOptionUtil.getDefaultTab(report.analyze_target_code)
      }
      let stateChartOptions = chartOptionUtil.createChartOptions(
        chartData.data.detail_info, report.analyze_target_code,
        report.conditions_groupby, report.conditions_type_mode, chartData.type, null, report.conditions_term, param.ages)
      if (!_.isEmpty(stateChartOptions)) {
        report.chartOptions = stateChartOptions[0]
      }
    }
    state.reportsOnDashboard['' + report.history_id] = report
  },
  setTabType (state, tabType) {
    state.tabType = tabType
  },
  setCharDataAnalyzeTargetCode (state, data) {
    state.chartData.analyzeTargetCode = data
  },
  setCharDataHistoryId (state, data) {
    state.chartData.historyId = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
